module.exports = __webpack_public_path__ + "static/media/efisien.e66f6c94.png";